<script>
    import { beforeUpdate } from 'svelte';
    import {push} from 'svelte-spa-router';
    import {db,data} from "../store";

    export let params;
    let estado = 0;
    let image = '/ArteLogo.png';

    beforeUpdate(()=>{
        if (params && params.id){
            if (params.id == 'undefined' || params.id == undefined){
                estado = 0;
                $data.url = undefined;
                $data.local = undefined;
                $data.titulo = undefined;
            } else {
                estado = 1;
                $data.fecha = {};
                $data.mayor = {fecha:{}}
                switch(params.id){
                    case 'SM':
                        $data.url = 'SM';
                        $data.local = 'local:San Martin';
                        $data.titulo = 'San Martín';
                        $data.dbLocal = 'San Martin';
                        image = "/arteaflordepieltattoo.jpeg"
                        break;
                    case 'SF':
                        $data.url = 'SF';
                        $data.local = 'local:Santa Fe';
                        $data.titulo = 'Santa Fe';
                        $data.dbLocal = 'Santa Fe';
                        image = '/ArteLogo.png';
                        break;
                    case 'C':
                        $data.url = 'C';
                        $data.local = 'local:Costa';
                        $data.titulo = 'Costa';
                        $data.dbLocal = 'Costa';
                        image = '/ArteLogo.png';
                        break;
                    case 'G':
                        $data.url = 'G';
                        $data.local = 'local:Guemes';
                        $data.titulo = 'Güemes';
                        $data.dbLocal = 'Guemes';
                        image = '/ArteLogo.png';
                        break;
                }
            }
        }
    })
    function elegir(sucursal){
        push(`/${sucursal}`);
    }
</script>
<div class="flex flex-col items-center justify-start p-4">
{#if estado == 0}
    <div on:click={()=>elegir("SM")} class="p-2 mb-2 mt-4 rounded shadow bg-red-500 text-white flex items-center justify-center cursor-pointer hover:bg-red-300 w-full">San Martin</div>
    <div on:click={()=>elegir("SF")} class="p-2 mb-2 rounded shadow bg-red-500 text-white flex items-center justify-center cursor-pointer hover:bg-red-300 w-full">Santa Fe</div>
    <div on:click={()=>elegir("C")} class="p-2 mb-2 rounded shadow bg-red-500 text-white flex items-center justify-center cursor-pointer hover:bg-red-300 w-full">Costa</div>
    <div on:click={()=>elegir("G")} class="p-2 mb-2 rounded shadow bg-red-500 text-white flex items-center justify-center cursor-pointer hover:bg-red-300 w-full">Güemes</div>
{:else}
    <div class="w-8/12 rounded-full overflow-hidden">
        <img src={image} alt={$data.titulo} />
    </div>
    <div class="w-full text-center font-bold text-xl m-2">
        Sucursal: {$data.titulo}
    </div>
    <div on:click={()=>elegir("datos")} class="p-2 mb-2 rounded shadow bg-red-500 text-white flex items-center justify-center cursor-pointer hover:bg-red-300 w-full">Iniciar</div>
{/if}
</div>